import CategoriaOrdemServicoService from "@/services/CategoriaOrdemServicoService";

export const categoriaOrdemServico = {
  namespaced: true,
  state: {
    categoriaOrdemServico: {},
  },
  actions: {
    getCategoriaOrdemServico({ commit }, payload) {
      return CategoriaOrdemServicoService.GetCategoriaOrdemServico(
        payload
      ).then(
        (categoriaOrdemServico) => {
          return Promise.resolve(categoriaOrdemServico);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    postCategoriaOrdemServico({ commit }, payload) {
      return CategoriaOrdemServicoService.PostCategoriaOrdemServico(
        payload
      ).then(
        (categoriaOrdemServico) => {
          return Promise.resolve(categoriaOrdemServico);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    putCategoriaOrdemServico({ commit }, payload) {
      return CategoriaOrdemServicoService.PutCategoriaOrdemServico(
        payload
      ).then(
        (categoriaOrdemServico) => {
          return Promise.resolve(categoriaOrdemServico);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    deleteCategoriaOrdemServico({ commit }, payload) {
      return CategoriaOrdemServicoService.DeleteCategoriaOrdemServico(
        payload
      ).then(
        (response) => {
          return Promise.resolve(response);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    getCategoriaOrdemServicoOData({ commit }, payload) {
      return CategoriaOrdemServicoService.GetCategoriaOrdemServicoOData(
        payload
      ).then(
        (categoriaOrdemServico) => {
          return Promise.resolve(categoriaOrdemServico);
        },
        (error) => {
          return Promise.reject(error);
        }
      );
    },
  },
  mutations: {},
};

export default categoriaOrdemServico;
